import {
    Box,
    Text,
} from '@chakra-ui/react';

import AdvisoryCommitteeIntro from './AdvisoryCommitteeIntro';
import { ADVISORY_MEMBERS } from '../Components/info_all_members';
import { SimpleMemberCard } from '../Components/MemberCard';
import { useLanguage } from '../i18n/LanguageContext';
import { Navigate } from 'react-router-dom';


const AdvisoryCommittee = () => {
    const { isEnglish, t } = useLanguage();
    if (isEnglish) return <Navigate to="/" replace />;

    return (
        <Box
            bg="#edf3f8"
            p={10}
            w="full"
        >
            <AdvisoryCommitteeIntro></AdvisoryCommitteeIntro>
            {ADVISORY_MEMBERS.map((cardInfo, index) => {
                return (
                    <>
                        {<Box
                            mt={14}
                            borderRadius='md'
                            backgroundColor='#1E646E' // 職稱 title 深綠色
                        >
                            {index === 0 ? <Text
                                fontWeight='bold'
                                fontSize='3xl'
                                color='white'>
                                {t('advisory.convener')}
                            </Text> :
                                (index === 1 ? <Text
                                    fontWeight='bold'
                                    fontSize='3xl'
                                    color='white'>
                                    {t('advisory.member')}
                                </Text> : <></>)}
                        </Box>}
                        <SimpleMemberCard {...cardInfo} index={index} group={'Advisory'} />
                    </>
                )
            })}
        </Box>
    )
}
export default AdvisoryCommittee;
